import React, { useEffect, useState } from "react";
import axios from "@/lib/axios";
import { API_BASE_URL } from "@/config";
import FullScreenLoader from "@/components/FullScreenLoader";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import IntellendLogo from "@/components/IntellendLogo";
import { useJourney } from "@/contexts/JourneyContext";

const InternalRulesWhitespace = () => {
  const navigate = useNavigate();
  const { refresh: refreshJourney } = useJourney();
  const [timeLeft, setTimeLeft] = useState(0);
  const [isPending, setIsPending] = useState(false);

  const triggerRulesetWhitespace = async () => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/trigger_ruleset_whitespace/`,
        {}
      );
      const nextPage = res.data?.next_page_url || res.data?.redirect_url;
      if (nextPage) {
        navigate(nextPage);
      }

      if (res.data.verification_status === 'pending') {
        setIsPending(true);
        setTimeLeft(10); // 10 seconds
      } else if (res.data.redirect_url) {
        await refreshJourney();
        navigate(res.data.redirect_url);
      }
    } catch (err) {
      console.error("Failed to trigger ruleset whitespace:", err);
      // On error, maybe retry after some time too?
      setIsPending(true);
      setTimeLeft(10);
    }
  };

  useEffect(() => {
    triggerRulesetWhitespace();
  }, []);

  useEffect(() => {
    if (timeLeft <= 0) {
      if (isPending) {
        setIsPending(false);
        triggerRulesetWhitespace();
      }
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, isPending]);

  return (
    <div className="min-h-screen bg-white flex flex-col justify-center items-center p-4">
      <div className="flex flex-col items-center text-center max-w-sm">
        <div className="mb-8">
          <IntellendLogo size="md" />
        </div>

        <div className="relative mb-8">
          <div className="w-16 h-16 border-4 border-intellend-green/20 border-t-intellend-green rounded-full animate-spin"></div>
        </div>

        <h1 className="text-xl font-semibold text-gray-800 mb-2">
          Verifying Your Details
        </h1>
        <p className="text-gray-500 mb-8">
          We are performing a few internal checks to provide you with the best loan offer. This usually takes less than a minute.
        </p>

        {timeLeft > 0 && (
          <div className="bg-slate-50 px-6 py-3 rounded-full border border-slate-100 flex items-center gap-3">
            <span className="flex h-2 w-2 rounded-full bg-intellend-green animate-pulse"></span>
            <span className="text-sm font-medium text-slate-600">
              Checking again in {timeLeft}s
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default InternalRulesWhitespace;
